"use client";

import React, { useRef } from "react";
import Banner from "@/components/shared/Banner";
import NewsItem from "@/components/news/Item";

export default function NewsSlide({ news = [] }) {
  const newsSliderRef = useRef(null);

  const swiperOption = {
    speed: 1500,
    autoplay: false,
    spaceBetween: 24,
    breakpoints: {
      320: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      900: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
    },
  };

  const onSliderPrev = () => {
    if (newsSliderRef.current) {
      newsSliderRef.current.slidePrev();
    }
  };

  const onSliderNext = () => {
    if (newsSliderRef.current) {
      newsSliderRef.current.slideNext();
    }
  };

  return (
    <div className="relative w-full news-slider mx-auto">
      <div className="sm:block hidden">
        <button
          type="button"
          className="fas fa-chevron-left text-4xl !text-black-100/20 hover:!text-black-100 duration-200 cursor-pointer mr-3 bg-transparent border-none"
          onClick={onSliderPrev}
          aria-label="Previous news"
        />
        <button
          type="button"
          className="fas fa-chevron-right text-4xl !text-black-100/20 hover:!text-black-100 duration-200 cursor-pointer bg-transparent border-none"
          onClick={onSliderNext}
          aria-label="Next news"
        />
      </div>

      <div className="xl:pt-[120px] md:pt-[80px] pt-[40px] ">
        {news && news.length > 0 && (
          <Banner
            ref={newsSliderRef}
            slides={news}
            style={{ minHeight: "200px" }}
            controls={{ withNavigation: true }}
            options={swiperOption}
          >
            {({ slide: { item } }) => (
              <div className=" rounded overflow-hidden">
                <NewsItem isRespon={true} news={item} />
              </div>
            )}
          </Banner>
        )}
      </div>
    </div>
  );
}
